module.exports = __webpack_public_path__ + "img/blt-arrow02.742f8b16.svg";